import { ICrud } from "../types/common";
import { IPromotion } from "./Promotion";
import { IXeroPayment } from "../types/Payment";

export enum EVirtualVoucherStatus {
  USING = "USING",
  USED = "USED",
  NOT_USED = "NOT_USED",
}

export interface IVoucher extends ICrud {
  code: string;
  used: boolean;
  promotionId: string;
  promotion: IPromotion;

  xeroPaymentId?: string;
  xeroPayment?: IXeroPayment;
  heldAt?: Date | null;
}

export interface IbyUser {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  email: string;
  status: string;
  role: string;
  firstName: string;
  lastName: string;
  phone: string;
  whatsapp: null;
  resetPasswordToken: null;
  measuringId: null;
  photoId: null;
  agencyLogoId: null;
  company: string;
  additionalEmail: null;
  ownerId: null;
  changePasswordLogMessage: null;
  isFlowSignUp: boolean;
  pricingPlans: string;
  statusAccount: string;
  adRerportUrl: null;
  note: null;
}
